/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/

import { BrowserHistory } from 'history';
import React, { useState, useEffect } from 'react';
import { Router } from 'react-router-dom';

import { getPath } from '../../util/url';

export interface CustomHistoryRouterProps {
  children?: React.ReactNode;
  history: BrowserHistory;
}

/**
 * CustomHistoryRouter
 *
 * We are using a wrapper around the Router component so that we can keep on using util/history
 * and avoid using unstable_HistoryBrowser, see https://github.ibm.com/watson-engagement-advisor/wea-backlog/issues/62467
 */
export const CustomHistoryRouter: React.FC<CustomHistoryRouterProps> = ({
  children,
  history
}) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location
  });

  const appRoutingBaseName = getPath(document.baseURI);

  useEffect(() => history.listen(setState), [history]);

  return (
    <Router
      basename={appRoutingBaseName}
      location={state.location}
      navigator={history}
      navigationType={state.action}>
      {children}
    </Router>
  );
};
